var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{style:({
    'background-color': _vm.itemColor(_vm.item),
    'max-width':_vm.$vuetify.breakpoint.xsOnly? _vm.xsSize+'px':_vm.smSize+'px',
    'max-height':_vm.$vuetify.breakpoint.xsOnly? _vm.xsSize+'px':_vm.smSize+'px'
    })},[(_vm.itemAvatar(_vm.item) )?_c('img',{attrs:{"src":_vm.itemAvatar(_vm.item),"alt":_vm.item.name}}):_c('span',{staticClass:"white--text",style:('font-size:' + _vm.fontSize +'px')},[_vm._v(_vm._s(_vm.item.name.charAt(0).toUpperCase()))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-034cb1f8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ProvisionalAvatar.vue
// module id = 1318
// module chunks = 22